import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetRespondentFilterOptionsRPC } from "./getRespondentFilterOptionsRPC";

export class GetRespondentFilterOptionsRPCClientImpl extends GetRespondentFilterOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetRespondentFilterOptionsRPC.Request): Promise<LeoRPCResult<GetRespondentFilterOptionsRPC.Response, GetRespondentFilterOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetRespondentFilterOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetRespondentFilterOptionsRPC.ResponseDTO,
      GetRespondentFilterOptionsRPC.Errors.ErrorsDTO,
      GetRespondentFilterOptionsRPC.Response,
      GetRespondentFilterOptionsRPC.Errors.Errors
    >(
      response,
      "respondent/GetRespondentFilterOptions",
      GetRespondentFilterOptionsRPC.Response.fromDTO,
      GetRespondentFilterOptionsRPC.Errors.fromDTO
    );
  }
}
